import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { NavLink } from 'react-router-dom';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IAnagraficaListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPagineTipi_Anag;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class AnagraficaLista extends BaseComponent<Glob.IRouteGlobaleProps, IAnagraficaListaState> {

    private ParametriFissi: Dati.TListaParametri = {};

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        this.state = { Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreAnagrafica = this.OnErroreAnagrafica.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        //Con il bind si può scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [2, 5, 6], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_Anag", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("Denominazione", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 3:
                                this.OnOrdinamento("TipoAnagStato", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 4:
                                this.OnOrdinamento("TipoAnag", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }

    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPagineTipi_Anag, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={7} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr key={dato.ID_Anag}>
                        <td data-field="ID_Anag" className="TextCenter">
                            <a href="#" className="arrow" onClick={(e) => { e.preventDefault(); this.props.history.push("/anagrafica/" + dato.ID_Anag) }} >
                                {dato.ID_Anag}
                            </a>
                        </td>
                        <td data-field="RagioneSociale" className="TextLeft">{dato.RagioneSociale} {dato.Cognome} {dato.Nome}</td>
                        <td data-field="PIVA" className="TextLeft">{this.PIVACF(dato.PartitaIVA, dato.CodiceFiscale)}</td>
                        <td data-field="Status" className="TextLeft">{Trad.Trad(dato.TipoAnagStato)}</td>
                        <td data-field="Tipo" className="TextLeft">{Trad.Trad(dato.TipoAnag)}</td>
                        <td data-field="Addresses" className="TextCenter">
                            {this.Rubrica(dato.RecapitiJSON, dato.IndirizziJSON)}
                        </td>
                        <td data-field="edit" className="TextCenter">
                            <a href="#" className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" onClick={(e) => { e.preventDefault(); this.props.history.push("/anagrafica/" + dato.ID_Anag) }}>
                                <i className="la la-edit"></i>
                            </a>
                        </td>
                    </tr>
                )}
            </tbody>;
        }
        //<div className="divtabella"><ChiamaAPI URL="/api/ControlloLimiti" /></div>
    }

    private PIVACF(partitaIVA: string, codiceFiscale: string): string {
        if (partitaIVA == undefined || partitaIVA.length == 0) {
            if (codiceFiscale == undefined || codiceFiscale.length == 0) {
                return "";
            }
            else {
                return codiceFiscale;
            }
        }
        else {
            if (codiceFiscale == undefined || codiceFiscale.length == 0) {
                return partitaIVA;
            }
            else {
                return partitaIVA + "/" + codiceFiscale;
            }
        }
    }

    private Rubrica(jsonRubrica: string, jsonIndirizzi: string): any {
        let dati: Dati.CDatoRubrica[];
        let indirizzi: Dati.CDatoIndirizzo[];
        let result: any[] = [];
        if ((jsonRubrica || "").length > 0) {
            dati = JSON.parse(jsonRubrica);
            for (let i: number = 0; i < dati.length; i++) {
                result.push(<span className="dropdown-item" key={i}><i className={"la " + this.TipoIcona(dati[i].ID_Tipologia)}></i> {dati[i].Valore}</span>);
            }
        }
        if ((jsonIndirizzi || "").length > 0) {
            indirizzi = JSON.parse(jsonIndirizzi);
            for (let x: number = 0; x < indirizzi.length; x++) {
                result.push(<span className="dropdown-item" key={x + 100}><i className="la la-map-marker"></i> {indirizzi[x].Indirizzo} - {indirizzi[x].Cap} {indirizzi[x].Citta} {indirizzi[x].Provincia}</span>);
            }
        }

        if (result.length > 0) {
            return <div className="dropdown">
                <a href="#" className="kt-portlet__nav-link btn kt-btn kt-btn--hover-brand kt-btn--icon btn--icon-only kt-btn--pill" data-toggle="dropdown">
                    <i className="la la-book"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                    {result}
                </div>
            </div>;
        } else {
            return <div></div>;
        }
    }

    //VA PORTATO FUORI
    private TipoIcona(tipo: number): string {
        switch (tipo) {
            case 1:
                return "la-phone";
            case 2:
                return "la-mobile";
            case 3:
                return "la-fax";
            case 4:
                return "la-envelope";
            case 5:
                return "la-gavel";
        }
        return "la-edit";
    }

    private OnErroreAnagrafica(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={7}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public render() {
        let VisibileScrittura: string = "hidden";
        if (Glob.AzioneAbilitata("AnagController", Glob.Scrittura))
            VisibileScrittura = "";
        if (!Glob.AzioneAbilitata("AnagController", Glob.Lettura)) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-users"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Anagrafica")}</h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + VisibileScrittura} aria-expanded="true">
                            <NavLink to="/anagrafica/0" className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" title={Trad.Trad("Nuovo")}>
                                <i className="fa fa-plus"></i>
                            </NavLink>
                        </div>
                    </ul>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("ID")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["ID_Anag"] || ""} name="ParametriUtente[ID_Anag]" className="form-control kt-input" placeholder={Trad.Trad("ID")} />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Nome")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["Denominazione"] || ""} name="ParametriUtente[Denominazione]" className="form-control kt-input" placeholder={Trad.Trad("Denominazione")} />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("PIVACF")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["CodiceFiscalePartitaIVA"] || ""} name="ParametriUtente[CodiceFiscalePartitaIVA]" className="form-control kt-input" placeholder={Trad.Trad("PIVA")} />
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row">
                        <label className="col-lg-1 col-form-label">
                            {Trad.Trad("TipoAnagStato")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo IgnoraPermessi Campo="ParametriUtente[ID_TipoAnagStato]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoAnagStato"] || ""} OnAggiorna={this.OnChange} Dati={this.state.Dati != undefined ? this.state.Dati.Tipi["TipiAnagStati"] : undefined} />
                            </div>
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("TipoAnag")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <Tipo Campo="ParametriUtente[ID_TipoAnag]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoAnag"] || ""} OnAggiorna={this.OnChange} Dati={this.state.Dati != undefined ? this.state.Dati.Tipi["TipiAnagPrincipale"] : undefined} />
                        </div>
                        <label className="col-lg-1 col-form-label hidden">
                            {Trad.Trad("Sede")}</label>
                        <div className="col-lg-3 hidden form-control-plaintext">
                            <div className="kt-input-icon kt-input-icon--right">
                                <input type="text" className="form-control kt-input" placeholder={Trad.Trad("Sede")} value={this.state.ParametriUtente["Sede"] || ""} name="ParametriUtente[Sede]" onChange={this.OnChange} />
                                <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                    <span>
                                        <i className="la la-map-marker"></i>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                        <div className="row">
                            <div className="col kt-form__actions kt-form__actions--center">
                                <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
            <div>
                <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                    <thead>
                        <tr className="sfondoTab">
                            <th data-field="ID_Anag" className="TextCenter">ID</th>
                            <th data-field="Denominazione" className="TextLeft">{Trad.Trad("Nome")}</th>
                            <th data-field="PIVACF" className="TextLeft"> {Trad.Trad("PIVACF")}</th>
                            <th data-field="TipoAnagStato" className="TextLeft"> {Trad.Trad("Stato")}</th>
                            <th data-field="TipoAnag" className="TextLeft">{Trad.Trad("Tipo")}</th>
                            <th data-field="Recapiti" className="TextCenter"> {Trad.Trad("Recapiti")}</th>
                            <th className="TextCenter">{Trad.Trad("Modifica")}</th>
                        </tr>
                    </thead>
                    <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/Anag/Ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreAnagrafica} />
                </table>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/AnagraficaLista.tsx